const state = {
  main: {
    name: 'Manoj Kumar',
    position: 'Admin',
    state: {
      color: '#3c763d',
      name: 'Online'
    },
    createdAt: new Date()
  }
}

const mutations = {

}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js